// extracted by mini-css-extract-plugin
module.exports = {"listCard":"listcard_listCard__3RU_L"};